import {Injectable,} from '@angular/core';
import {environment,} from '@environments/environment';
import {Decimal,} from 'decimal.js';

@Injectable()
export class SystemConstant {
  // 画面用APIのパス設定
  public readonly SERVER_HOST = environment.server_host;
  public readonly API_PATH = environment.endpoint.api;

  // メッセージレベル別のSnackbarの表示時間
  public readonly MESSAGE_DURATION = {
    error: 10000, // 10秒
    warn: 10000,  // 10秒
    info: 10000,  // 10秒
  };

  // SMS:スマフォのデフォルト画面サイズ
  public readonly DEFAULT_DEVICE_SCREEN_WIDTH = 390;
  // SMS:デフォルト言語区分(01:日本語)
  public readonly DEFAULT_LANGUAGE_TYPE = '01';
  // SMS:許可済み取引メニュー番号一覧
  public readonly ARRAY_PERMITTED_MENU_NO = ['01', '02', '03', '04', '05', '06', '07', '08', '99',];

  // PCのデフォルトのページサイズ
  public readonly DEFAULT_PC_SCREEN_HEIGHT = 1024;
  public readonly DEFAULT_PC_SCREEN_WIDTH = 1280;
  // PCとモバイルを識別する画面サイズの境界線(ピクセルで指定)
  public readonly SCREEN_TYPE_RECOGNITION_WIDTH = 960;

  // PCのデフォルトの子画面サイズ
  public readonly DEFAULT_PC_CHILD_SCREEN_HEIGHT = 1040;
  public readonly DEFAULT_PC_CHILD_SCREEN_WIDTH = 1675;

  // Top画面の画面ID(共通ID)
  public readonly GO_TOP = 'CSS01001';
  // 表示日付形式
  public readonly DATE_FORMAT_DISPLAY_YYYYMM = 'YYYY-MM';
  public readonly DATE_FORMAT_DISPLAY_YYYYMMDD = 'YYYY-MM-DD';
  // 値取得ための日付形式
  public readonly DATE_FORMAT_DATA_YYYYMM = 'YYYYMM';
  public readonly DATE_FORMAT_DATA_YYYYMMDD = 'YYYYMMDD';

  /** エンプティの定数値 */
  public static readonly EMPTY = '';

  /** 性別 */
  public static readonly C_SEX_MALE = 'M';
  public static readonly C_SEX_MALE_NAME = '男';
  public static readonly C_SEX_FEMALE = 'F';
  public static readonly C_SEX_FEMALE_NAME = '女';
  public static readonly C_SEX_UNKNOWN = 'U';
  public static readonly C_SEX_UNKNOWN_NAME = '不明';

  /** 固定長充足文字区分 */
  public static readonly FIXED_PAD_VAL_KBN = {
    Space: 0, // スペース埋
    Zero: 1, // ０埋
  };

  /** 固定長詰め区分 */
  public static readonly FIXED_SHIFT_KBN = {
    Right: 0, // 右寄せ
    Left: 1, // 左寄せ
  };

  /** 切捨区分 */
  public static readonly FIXED_ROUND_DOWN_KBN = {
    Right: 0, // 右側切捨
    Left: 1, // 左側切捨
  };

  /** 全角区分 */
  public static readonly FIXED_ZENKAKU_KBN = {
    Hankaku: 1, // 半角
    Zenkaku: 2, // 全角
  };

  /** 日付型の最小値の作成 */
  public static readonly DATE_MIN = '0001-01-01T00:00:00';
  public static readonly DATE_MIN_VALUE = '0001/01/01 00:00:00';

  /** 日付型の最小値の作成 */
  public static readonly DATE_MIN_FORMAT_YYYY_MM_DD = '0001/01/01';

  /** ハイフン定数 */
  public static readonly HYPHEN = '-';

  /** スラッシュ定数 */
  public static readonly SLASH = '/';

  /** 年定数 */
  public static readonly YEAR_JP = '年';

  /** 月定数 */
  public static readonly MONTH_JP = '月';

  /** 日定数 */
  public static readonly DAY_JP = '日';

  /** 時間定数 */
  public static readonly HOUR_JP = '時';

  /** 分定数 */
  public static readonly MINUTES_JP = '分';

  /** 時間フォーマット(YYYY/MM/DD) */
  public static readonly DATE_FORMAT_YYYY_MM_DD_SLASH = 'YYYY/MM/DD';

  /** 時間フォーマット(YYYY年MM月DD日) */
  public static readonly DATE_FORMAT_YYYY_MM_DD_JP = 'YYYY年MM月DD日';

  /** 時間フォーマット(YYYY年M月D日) */
  public static readonly DATE_FORMAT_YYYY_M_D_JP = 'YYYY年M月D日';

  /** 時間フォーマット(MM月DD日) */
  public static readonly DATE_FORMAT_MM_DD_JP = 'MM月DD日';

  /** 時間フォーマット(YYYY/MM) */
  public static readonly DATE_FORMAT_YYYY_MM_SLASH = 'YYYY/MM';

  /** 時間フォーマット(YYYY年MM月) */
  public static readonly DATE_FORMAT_YYYY_MM_JP = 'YYYY年MM月';

  /** 時間フォーマット(YYYY/MM/DD) */
  public static readonly DATE_FORMAT_YYYYMMDD = 'YYYY/MM/DD';

  /** 時間フォーマット(HH時mm分ss) */
  public static readonly DATE_FORMAT_HHMMSS_JP = 'HH時mm分ss';

  /** Decimal型のパターン */
  public static readonly PATTERN_FORMAT_DECIMAL = /(\d)(?=(\d{3})+(?!\d))/g;

  /** 時間フォーマット(YYYY/MM/DD HH:mm:ss)*/
  public static readonly DATE_FORMAT_YYYYMMDDHHMMSS = 'YYYY/MM/DD HH:mm:ss';

  /** 時間フォーマット(YYYY/MM/DD HH:mm)*/
  public static readonly DATE_FORMAT_YYYYMMDDHHMM = 'YYYY/MM/DD HH:mm';

  /** 時間フォーマット(YYYY/MM/DD H:mm:ss)*/
  public static readonly DATE_FORMAT_YYYYMMDDHMMSS = 'YYYY/MM/DD H:mm:ss';

  /** 時間フォーマット(YYYY/MM/DD HH:mm:ss)*/
  public static readonly DATE_FORMAT_HHMM = 'HH:mm';
  /** 時間フォーマット(YYYY/MM/DD HH:mm:ss)*/
  public static readonly DATE_FORMAT_MMDDYYYYHHMMSSA = 'MM/DD/YYYY HH:mm:ss A';

  /** 登録中 */
  public static readonly KEIYAKU_STS_TOUROKU_CHU = '01';
  public static readonly C_KEIYAKU_STS_TOUROKU_CHU_CODE = 0;
  public static readonly KEIYAKU_STS_TOUROKU_CHU_NAME = '登録中';

  /** 審査保留キャンセル */
  public static readonly KEIYAKU_STS_SHINSA_HORYU_CANCEL = '04';
  public static readonly C_KEIYAKU_STS_SHINSA_HORYU_CANCEL_CODE = 1;
  public static readonly KEIYAKU_STS_SHINSA_HORYU_CANCEL_NAME = '審査保留キャンセル';

  /** 審査欠番 */
  public static readonly KEIYAKU_STS_SHINSA_KETSUBAN = '05';
  public static readonly C_KEIYAKU_STS_SHINSA_KETSUBAN_CODE = 2;
  public static readonly KEIYAKU_STS_SHINSA_KETSUBAN_NAME = '審査欠番';

  /** 審査確定 */
  public static readonly KEIYAKU_STS_SINSA_KAKUTEI = '02';
  public static readonly C_KEIYAKU_STS_SINSA_KAKUTEI_CODE = 3;
  public static readonly KEIYAKU_STS_SINSA_KAKUTEI_NAME = '審査確定';

  /** 審査OK後キャンセル */
  public static readonly KEIYAKU_STS_SINSA_CANCEL = '03';
  public static readonly C_KEIYAKU_STS_SINSA_CANCEL_CODE = 4;
  public static readonly KEIYAKU_STS_SINSA_CANCEL_NAME = '審査OK後キャンセル';

  /** 契約確定 */
  public static readonly KEIYAKU_STS_KEIYAKU_KAKUTEI = '11';
  public static readonly C_KEIYAKU_STS_KEIYAKU_KAKUTEI_CODE = 5;
  public static readonly KEIYAKU_STS_KEIYAKU_KAKUTEI_NAME = '契約確定';

  /** 解約確定 */
  public static readonly KEIYAKU_STS_KAIYAKU_KAKUTEI = '22';
  public static readonly C_KEIYAKU_STS_KAIYAKU_KAKUTEI_CODE = 6;
  public static readonly KEIYAKU_STS_KAIYAKU_KAKUTEI_NAME = '解約確定';

  /** 家賃支払停止中 */
  public static readonly KEIYAKU_STS_SIHARAI_STOP = '31';
  public static readonly C_KEIYAKU_STS_SIHARAI_STOP_CODE = 7;
  public static readonly KEIYAKU_STS_SIHARAI_STOP_NAME = '家賃支払停止中';
  /** 入金方法 */
  public static readonly C_NYUKIN_HOUHOU_HIKIOTOSI = '1';
  public static readonly C_NYUKIN_HOUHOU_HIKIOTOSI_NAME = '引落';
  public static readonly C_NYUKIN_HOUHOU_CVS = '2';
  public static readonly C_NYUKIN_HOUHOU_CVS_NAME = '初回CVS';
  public static readonly C_NYUKIN_HOUHOU_FURIKOMI = '3';
  public static readonly C_NYUKIN_HOUHOU_FURIKOMI_NAME = '振込';
  public static readonly C_NYUKIN_HOUHOU_HIKIOTOSI_ERROR = '4';
  public static readonly C_NYUKIN_HOUHOU_HIKIOTOSI_ERROR_NAME = '引落エラーによるCVS';
  public static readonly C_NYUKIN_HOUHOU_CVS_TOKUSOKU1 = '5';
  public static readonly C_NYUKIN_HOUHOU_CVS_TOKUSOKU1_NAME = '督促CVS（1回目）';
  public static readonly C_NYUKIN_HOUHOU_CVS_TOKUSOKU2 = '6';
  public static readonly C_NYUKIN_HOUHOU_CVS_TOKUSOKU2_NAME = '督促CVS（2回目）';
  public static readonly C_NYUKIN_HOUHOU_SONOTA = '7';
  public static readonly C_NYUKIN_HOUHOU_SONOTA_NAME = 'その他';
  public static readonly C_NYUKIN_HOUHOU_FURIKOMI30 = '8';
  public static readonly C_NYUKIN_HOUHOU_FURIKOMI30_NAME = '振込(30万円以上)';
  public static readonly C_NYUKIN_HOUHOU_FURIKOMI30_AMOUNT = 300000;
  public static readonly C_NYUKIN_HOUHOU_FIRST_FURIKOMI = 'A';
  public static readonly C_NYUKIN_HOUHOU_FIRST_FURIKOMI_NAME = '初回振込案内';
  public static readonly C_NYUKIN_HOUHOU_ERROR_FURIKOMI = 'B';
  public static readonly C_NYUKIN_HOUHOU_ERROR_FURIKOMI_NAME = '引落エラーによる振込';
  public static readonly C_NYUKIN_HOUHOU_TOKUSOKU_FURIKOMI1 = 'C';
  public static readonly C_NYUKIN_HOUHOU_TOKUSOKU_FURIKOMI1_NAME = '督促振込（1回目）';
  public static readonly C_NYUKIN_HOUHOU_TOKUSOKU_FURIKOMI2 = 'D';
  public static readonly C_NYUKIN_HOUHOU_TOKUSOKU_FURIKOMI2_NAME = '督促振込（2回目）';

  /** 入金（収納）ステータス */
  public static readonly C_NYUKIN_STS_HIKIATE = '0';
  public static readonly C_NYUKIN_STS_HIKIATE_NAME = '引当中';
  public static readonly C_NYUKIN_STS_MI = '1';
  public static readonly C_NYUKIN_STS_MI_NAME = '未';
  public static readonly C_NYUKIN_STS_IRAITYU = '2';
  public static readonly C_NYUKIN_STS_IRAITYU_NAME = '依頼中';
  public static readonly C_NYUKIN_STS_NYUKIN_SUMI = '3';
  public static readonly C_NYUKIN_STS_NYUKIN_SUMI_NAME = '入金済み';
  public static readonly C_NYUKIN_STS_NYUKIN_NG = '4';
  public static readonly C_NYUKIN_STS_NYUKIN_NG_NAME = '入金NG';
  public static readonly C_NYUKIN_STS_FUYOU = '5';
  public static readonly C_NYUKIN_STS_FUYOU_NAME = '不要';
  public static readonly C_NYUKIN_STS_HENMATI = '6';
  public static readonly C_NYUKIN_STS_HENMATI_NAME = '返金依頼待ち';
  public static readonly C_NYUKIN_STS_HENCHU = '7';
  public static readonly C_NYUKIN_STS_HENCHU_NAME = '返金依頼中';
  public static readonly C_NYUKIN_STS_SOUSAI = '8';
  public static readonly C_NYUKIN_STS_SOUSAI_NAME = '翌月相殺';
  /**
   * 金融機関区分
   * 郵便局
   */
  public static readonly BANK_POST_KBN_POST = '1';
  public static readonly BANK_POST_KBN_POST_NAME = '郵便局';

  /** 民間金融機関 */
  public static readonly BANK_POST_KBN_BANK = '2';
  public static readonly BANK_POST_KBN_BANK_NAME = '民間金融機関';

  /**
   * 預金種別
   * 入金（R社口座）普通/当座種別
   */
  public static readonly C_NYUKIN_RS_KOZA_SHBT_FUTSU = '1';
  public static readonly C_NYUKIN_RS_KOZA_SHBT_FUTSU_NAME = '普通';
  public static readonly C_NYUKIN_RS_KOZA_SHBT_TOZA = '2';
  public static readonly C_NYUKIN_RS_KOZA_SHBT_TOZA_NAME = '当座';

  /**免責フラグ*/
  public static readonly C_MENSEKI_FLG_ON_NAME = '免責';
  public static readonly C_MENSEKI_FLG_OFF_NAME = '-';

  /**免責フラグON*/
  public static readonly C_MENSEKI_FLG_ON = '1';

  /**免責フラグOFF*/
  public static readonly C_MENSEKI_FLG_OFF = '0';

  /**保証終了フラグ*/
  public static readonly C_HOSHO_END_FLG_ON_NAME = '終了';
  public static readonly C_HOSHO_END_FLG_OFF_NAME = '-';

  /**保証終了フラグON*/
  public static readonly C_HOSHO_END_FLG_ON = '1';

  /**保証終了フラグOFF*/
  public static readonly C_HOSHO_END_FLG_OFF = '0';

  /**処理結果ステータス*/
  public static readonly C_TODO_TAIOU_KBN_SHUDO = '00'; //手動
  public static readonly C_TODO_TAIOU_KBN_NYUKIN_STOP = '01'; //入金停止
  public static readonly C_TODO_TAIOU_KBN_SHUKKIN_STOP = '02'; //出金停止
  public static readonly C_TODO_TAIOU_KBN_NYUSHUKKIN_STOP = '03'; //入出金停止
  public static readonly C_TODO_TAIOU_KBN_KINGAKU_HENKOU = '04'; //金額変更
  public static readonly C_TODO_TAIOU_KBN_SHUDO_NAME = '手動';
  public static readonly C_TODO_TAIOU_KBN_NYUKIN_STOP_NAME = '入金停止';
  public static readonly C_TODO_TAIOU_KBN_SHUKKIN_STOP_NAME = '出金停止';
  public static readonly C_TODO_TAIOU_KBN_NYUSHUKKIN_STOP_NAME = '入出金停止';
  public static readonly C_TODO_TAIOU_KBN_KINGAKU_HENKOU_NAME = '金額変更';

  /**処理結果ステータス*/
  public static readonly C_SHORI_STS_INFO = '000'; //[INFO]正常終了
  public static readonly C_SHORI_STS_WAR1 = '100'; //[WARN]必須エラー
  public static readonly C_SHORI_STS_WAR2 = '200'; //[WARN]範囲エラー
  public static readonly C_SHORI_STS_ERR1 = '900'; //[ERROR]必須エラー
  public static readonly C_SHORI_STS_ERR2 = '999'; //[ERROR]異常終了
  public static readonly C_SHORI_STS_INFO_NAME = '[INFO]正常終了'; //[INFO]正常終了の和名
  public static readonly C_SHORI_STS_WAR1_NAME = '[WARN]必須エラー'; //[WARN]必須エラーの和名
  public static readonly C_SHORI_STS_WAR2_NAME = '[WARN]範囲エラー'; //[WARN]範囲エラーの和名
  public static readonly C_SHORI_STS_ERR1_NAME = '[ERROR]必須エラー'; //[ERROR]必須エラーの和名
  public static readonly C_SHORI_STS_ERR2_NAME = '[ERROR]異常終了'; //[ERROR]異常終了の和名

  /**口振不備対応中フラグ*/
  public static readonly C_HIKIOTOSI_IRAI_FLG_NEW = '1'; // 新規
  public static readonly C_HIKIOTOSI_IRAI_FLG_NEW_NAME = '新規';
  public static readonly C_HIKIOTOSI_IRAI_FLG_CONTINUE = '0'; // 継続
  public static readonly C_HIKIOTOSI_IRAI_FLG_CONTINUE_NAME = '継続';

  /**口振不備対応中フラグ*/
  public static readonly KOUFURI_FUBI_FLG_NASI = '0'; //不備無
  public static readonly KOUFURI_FUBI_FLG_NASI_NAME = '不備無';
  public static readonly KOUFURI_FUBI_FLG_TAIOU = '1'; //対応中
  public static readonly KOUFURI_FUBI_FLG_TAIOU_NAME = '対応中';

  /**家賃収納区分フラグ*/
  public static readonly C_YATIN_SHUNOU_KBN_HIKI = '1'; // 引落
  public static readonly C_YATIN_SHUNOU_KBN_HIKI_NAME = '引落';
  public static readonly C_YATIN_SHUNOU_KBN_FURI = '2'; // 引落
  public static readonly C_YATIN_SHUNOU_KBN_FURI_NAME = '振込';

  /**口振実績ステータス*/
  public static readonly KEIYAKU_KOUFURI_JISSEKI_STS_NASI = '1'; // 無
  public static readonly KEIYAKU_KOUFURI_JISSEKI_STS_NASI_NAME = '無';
  public static readonly KEIYAKU_KOUFURI_JISSEKI_STS_ARI = '2'; // 有
  public static readonly KEIYAKU_KOUFURI_JISSEKI_STS_ARI_NAME = '有';

  /**電話番号登録区分*/
  public static readonly C_TEL_TOUROKU_KBN_ADD_TEL = '1';
  public static readonly C_TEL_TOUROKU_KBN_ADD_TEL_NAME = '追加';
  public static readonly C_TEL_TOUROKU_KBN_NIPPOU = '2';
  public static readonly C_TEL_TOUROKU_KBN_NIPPOU_NAME = '日報';
  public static readonly C_TEL_TOUROKU_KBN_KEIYAKU = '3';
  public static readonly C_TEL_TOUROKU_KBN_KEIYAKU_NAME = '契約';

  /**電話区分*/
  public static readonly C_TEL_KBN_NONE = '0';
  public static readonly C_TEL_KBN_NONE_NAME = '';
  public static readonly C_TEL_KBN_TEL = '1';
  public static readonly C_TEL_KBN_TEL_NAME = '固定';
  public static readonly C_TEL_KBN_MOBILE = '2';
  public static readonly C_TEL_KBN_MOBILE_NAME = '携帯';

  /**カード回収状況*/
  public static readonly CARD_KAISHU_JOKYO_RIYOUCHU = '0'; //利用中
  public static readonly CARD_KAISHU_JOKYO_RIYOUCHU_NAME = '利用中';
  public static readonly CARD_KAISHU_JOKYO_MIKAISHU = '1'; //未回収
  public static readonly CARD_KAISHU_JOKYO_MIKAISHU_NAME = '未回収';
  public static readonly CARD_KAISHU_JOKYO_KAISHUZUMI = '2'; //回収済み
  public static readonly CARD_KAISHU_JOKYO_KAISHUZUMI_NAME = '回収済み';

  /**利息非加算フラグ (0:加算 1:非加算)*/
  public static readonly C_RISOKU_NOT_ADD_FLG_FALSE = '0'; // 加算
  public static readonly C_RISOKU_NOT_ADD_FLG_FALSE_NAME = '加算';
  public static readonly C_RISOKU_NOT_ADD_FLG_TRUE = '1'; // 非加算
  public static readonly C_RISOKU_NOT_ADD_FLG_TRUE_NAME = '非加算';

  /**家賃収納月区分（1:翌月 2:当月）*/
  public static readonly C_YATIN_SHUNOU_TUKI_KBN_YOKUGETU = '1'; // 翌月
  public static readonly C_YATIN_SHUNOU_TUKI_KBN_YOKUGETU_NAME = '翌月';
  public static readonly C_YATIN_SHUNOU_TUKI_KBN_TOGETU = '2'; // 当月
  public static readonly C_YATIN_SHUNOU_TUKI_KBN_TOGETU_NAME = '当月';
  /**振込ステータス*/
  public static readonly C_FURIKOMI_STS_MI = '1';
  public static readonly C_FURIKOMI_STS_MI_NAME = '未';
  public static readonly C_FURIKOMI_STS_IRAICHU = '2';
  public static readonly C_FURIKOMI_STS_IRAICHU_NAME = '依頼中';
  public static readonly C_FURIKOMI_STS_IRAIZUMI = '3';
  public static readonly C_FURIKOMI_STS_IRAIZUMI_NAME = '振込済み';
  public static readonly C_FURIKOMI_STS_FURIKOMI_NG = '4';
  public static readonly C_FURIKOMI_STS_FURIKOMI_NG_NAME = '振込NG';
  public static readonly C_FURIKOMI_STS_FURIKOMI_FUYOU = '5';
  public static readonly C_FURIKOMI_STS_FURIKOMI_FUYOU_NAME = '振込不要';

  /**印刷可不可フラグ*/
  public static readonly PRINT_FLG_OFF = '0'; //不可
  public static readonly PRINT_FLG_OFF_NAME = '不可';
  public static readonly PRINT_FLG_ON = '1'; //可
  public static readonly PRINT_FLG_ON_NAME = '可';

  /**大家区分*/
  public static readonly C_OYA_KBN_KOJIN = '1'; // 個人
  public static readonly C_OYA_KBN_KOJIN_NAME = '個人';
  public static readonly C_OYA_KBN_HOJIN = '2'; // 法人
  public static readonly C_OYA_KBN_HOJIN_NAME = '法人';
  public static readonly C_OYA_KBN_FUDOSAN_KAISHA = '3'; // 不動産会社
  public static readonly C_OYA_KBN_FUDOSAN_KAISHA_NAME = '不動産会社';

  /**保証終了フラグOFF*/
  public static readonly KOUFURI_KOZA_HENKOU_FLG_FIRST = '1'; // 初回口座/変更済
  public static readonly KOUFURI_KOZA_HENKOU_FLG_FIRST_NAME = '初回口座/変更済';
  public static readonly KOUFURI_KOZA_HENKOU_FLG_HENKO = '2'; // 口座変更対応中
  public static readonly KOUFURI_KOZA_HENKOU_FLG_HENKO_NAME = '口座変更対応中';

  /**口振完了ステータス*/
  public static readonly KOUFURI_KANRYO_STS_MI = '1'; // 未
  public static readonly KOUFURI_KANRYO_STS_MI_NAME = '未';
  public static readonly KOUFURI_KANRYO_STS_KAN = '2'; // 完
  public static readonly KOUFURI_KANRYO_STS_KAN_NAME = '完';

  /**店子区分*/
  public static readonly C_TANAKO_KBN_KOJIN = '1'; // 個人
  public static readonly C_TANAKO_KBN_KOJIN_NAME = '個人';
  public static readonly C_TANAKO_KBN_HOJIN = '2'; // 法人
  public static readonly C_TANAKO_KBN_HOJIN_NAME = '法人';

  /**画面定数定義*/
  public static readonly CHECKBOX_ON = '1'; // Checkboxオン
  public static readonly CHECKBOX_OFF = '0'; // Checkboxオフ
  /**権限、操作可否区分*/
  public static readonly C_AUTHORITY_KBN_USE = '1'; // 使用可能
  public static readonly C_AUTHORITY_KBN_REF = '2'; // 参照のみ可
  public static readonly C_AUTHORITY_KBN_NOT_USE = '3'; // 使用不可

  /**引落ステータス*/
  public static readonly C_HIKIOTOSI_STS_CSV = '0';
  public static readonly C_HIKIOTOSI_STS_CSV_NAME = 'ＣＳＶファイル出力待ち';
  public static readonly C_HIKIOTOSI_STS_IRAITYU = '1';
  public static readonly C_HIKIOTOSI_STS_IRAITYU_NAME = '依頼中';
  public static readonly C_HIKIOTOSI_STS_NYUKINSUMI = '2';
  public static readonly C_HIKIOTOSI_STS_NYUKINSUMI_NAME = '入金済み';
  public static readonly C_HIKIOTOSI_STS_NYUKIN_NG = '3';
  public static readonly C_HIKIOTOSI_STS_NYUKIN_NG_NAME = '入金NG';
  public static readonly C_HIKIOTOSI_STS_NYUKIN_ERR = '4';
  public static readonly C_HIKIOTOSI_STS_NYUKIN_ERR_NAME = '入金エラー';

  /**振込元金融機関名*/
  public static readonly C_FURIKOMI_MOTO_MIZUO = '0001';
  public static readonly C_FURIKOMI_MOTO_BTMU = '0005';
  public static readonly C_FURIKOMI_MOTO_SMBC = '0009';
  public static readonly C_FURIKOMI_MOTO_MIZUHOCORP = '0016';
  public static readonly C_FURIKOMI_MOTO_BTMU_NAME = 'BTMU';
  public static readonly C_FURIKOMI_MOTO_SMBC_NAME = 'SMBC';
  public static readonly C_FURIKOMI_MOTO_MIZUHO_NAME = 'みずほ';

  /**センター戻しフラグ*/
  public static readonly C_CENTER_BACK_FLG_DNP = '1'; // DNP局出し
  public static readonly C_CENTER_BACK_FLG_DNP_NAME = 'DNP局出し';
  public static readonly C_CENTER_BACK_FLG_CENTER = '2'; // センター戻し
  public static readonly C_CENTER_BACK_FLG_CENTER_NAME = 'センター戻し';

  /**明細出力区分*/
  public static readonly C_MEISAI_KBN_OUTPUT_OK = '1'; // 帳票出力有
  public static readonly C_MEISAI_KBN_OUTPUT_OK_NAME = '帳票出力有';
  public static readonly C_MEISAI_KBN_OUTPUT_NG = '2'; // 帳票出力無
  public static readonly C_MEISAI_KBN_OUTPUT_NG_NAME = '帳票出力無';

  /**審査フラグ*/
  public static readonly C_COMPANY_SITEN_SHINSA_FLG_FUKA = '0'; // 審査不可
  public static readonly C_COMPANY_SITEN_SHINSA_FLG_FUKA_NAME = '不'; // 審査不可の和名
  public static readonly C_COMPANY_SITEN_SHINSA_FLG_KA = '1'; // 審査可
  public static readonly C_COMPANY_SITEN_SHINSA_FLG_FAX = '2'; // FAX禁止
  public static readonly C_COMPANY_SITEN_SHINSA_FLG_FAX_NAME = '禁'; // FAX禁止の和名

  /**審査結果*/
  public static readonly SINSA_KEKKA_MI = '01'; // 未審査
  public static readonly SINSA_KEKKA_MI_NAME = '未審査';
  public static readonly SINSA_KEKKA_OK = '11'; // 審査OK
  public static readonly SINSA_KEKKA_OK_NAME = '審査OK';
  public static readonly SINSA_KEKKA_NG = '12'; // 審査NG
  public static readonly SINSA_KEKKA_NG_NAME = '審査NG';
  public static readonly SINSA_KEKKA_HANTEI_HUNO = '13'; // 判定不能
  public static readonly SINSA_KEKKA_HANTEI_HUNO_NAME = '判定不能';

  /**審査可不可フラグ*/
  public static readonly C_SHINSA_FLG_KA = '1'; // 審査可
  public static readonly C_SHINSA_FLG_KA_NAME = '-'; // 審査可の和名
  public static readonly C_SHINSA_FLG_FUKA = '0'; // 審査不可
  public static readonly C_SHINSA_FLG_FUKA_NAME = '不'; // 審査不可の和名

  /**削除フラグ*/
  public static readonly C_DEL_FLG_TRUE = '1'; // 削除有
  public static readonly C_DEL_FLG_FALSE = '0'; // 削除無
  public static readonly C_DEL_FLG_TRUE_NAME = '削除';
  public static readonly C_DEL_FLG_FALSE_NAME = '-'; // 削除無

  /**区分(OK/NG)*/
  public static readonly C_KBN_OK = '1'; // OK
  public static readonly C_KBN_OK_NAME = 'OK';
  public static readonly C_KBN_NG = '2'; // NG
  public static readonly C_KBN_NG_NAME = 'NG';

  /**済フラグ*/
  public static readonly C_ZUMI_FLG_ON = '1'; // 「済」フラグON
  public static readonly C_ZUMI_FLG_ON_NAME = '済'; // 「済」フラグONの和名
  public static readonly C_ZUMI_FLG_OFF = '0'; // 「済」フラグOFF
  public static readonly C_ZUMI_FLG_OFF_NAME = '-'; //「済」フラグOFFの和名

  /**契約種別*/
  public static readonly C_KEIYAKU_SHBT_KANRI_CHUKAI = '1'; // 管理会社＋仲介会社
  public static readonly C_KEIYAKU_SHBT_KANRI_CHUKAI_NAME = '管理会社＋仲介会社';
  public static readonly C_KEIYAKU_SHBT_CHUKAI = '2'; // 仲介会社
  public static readonly C_KEIYAKU_SHBT_CHUKAI_NAME = '仲介会社';
  public static readonly C_KEIYAKU_SHBT_KANRI = '3'; // 管理会社
  public static readonly C_KEIYAKU_SHBT_KANRI_NAME = '管理会社';

  /**入払区分（1:入金 2:出金）*/
  public static readonly C_IRI_HARAI_KBN_NYUKIN = '1';
  public static readonly C_IRI_HARAI_KBN_SHUKKIN = '2';
  public static readonly C_IRI_HARAI_KBN_NYUKIN_NAME = '入金';
  public static readonly C_IRI_HARAI_KBN_SHUKKIN_NAME = '出金';

  /**口振実績ステータス*/
  public static readonly KOUFURI_JISSEKI_STS_UKETORI = '1'; // 受取
  public static readonly KOUFURI_JISSEKI_STS_UKETORI_NAME = '受取';
  public static readonly KOUFURI_JISSEKI_STS_SHUNO_SOUFU = '2'; // 収納会社送付
  public static readonly KOUFURI_JISSEKI_STS_SHUNO_SOUFU_NAME = '収納会社送付';
  public static readonly KOUFURI_JISSEKI_STS_SHUNO_FUBI = '3'; // 収納会社不備戻り
  public static readonly KOUFURI_JISSEKI_STS_SHUNO_FUBI_NAME = '収納会社不備戻り';
  public static readonly KOUFURI_JISSEKI_STS_TENANTO_FUBI = '4'; // テナント不備送付
  public static readonly KOUFURI_JISSEKI_STS_TENANTO_FUBI_NAME = 'テナント不備送付';
  public static readonly KOUFURI_JISSEKI_STS_TENANT_SOUFUMATI = '5'; // テナント不備送付待ち
  public static readonly KOUFURI_JISSEKI_STS_TENANT_SOUFUMATI_NAME = 'テナント不備送付待ち';
  public static readonly KOUFURI_JISSEKI_STS_TOUROKUFUBI = '6'; // 登録不備
  public static readonly KOUFURI_JISSEKI_STS_TOUROKUFUBI_NAME = '登録不備';
  public static readonly KOUFURI_JISSEKI_STS_HOKAN = '7'; // 保管
  public static readonly KOUFURI_JISSEKI_STS_HOKAN_NAME = '保管';
  public static readonly KOUFURI_JISSEKI_STS_HASSOU = '8'; // 新口振発送
  public static readonly KOUFURI_JISSEKI_STS_HASSOU_NAME = '新口振発送';
  public static readonly KOUFURI_JISSEKI_STS_SONOTA = '9'; // その他
  public static readonly KOUFURI_JISSEKI_STS_SONOTA_NAME = 'その他';

  /**請求有無区分 0:無 1:有*/
  public static readonly C_SEIKYU_UMU_KBN_MU = '0';
  public static readonly C_SEIKYU_UMU_KBN_U = '1';
  public static readonly C_SEIKYU_UMU_KBN_MU_NAME = '無';
  public static readonly C_SEIKYU_UMU_KBN_U_NAME = '有';

  /**日割り区分 0:無 1:有*/
  public static readonly C_HIWARI_KBN_MU = '0';
  public static readonly C_HIWARI_KBN_U = '1';
  public static readonly C_HIWARI_KBN_MU_NAME = '無';
  public static readonly C_HIWARI_KBN_U_NAME = '有';

  /**損切りフラグ（0:無 1:有）*/
  public static readonly C_SONKIRI_FLG_TRUE = '1';
  public static readonly C_SONKIRI_FLG_FALSE = '0';
  public static readonly C_SONKIRI_FLG_TRUE_NAME = '有';
  public static readonly C_SONKIRI_FLG_FALSE_NAME = '無';

  /**預金種別*/
  public static readonly YOKIN_SHUBETSU_FUTSU = '1'; // 普通
  public static readonly YOKIN_SHUBETSU_FUTSU_NAME = '普通';
  public static readonly YOKIN_SHUBETSU_TOZA = '2'; // 当座
  public static readonly YOKIN_SHUBETSU_TOZA_NAME = '当座';

  /**会社一括/支店毎区分*/
  public static readonly C_SHUYAKU_KBN_COMPANY = '1'; // 会社一括
  public static readonly C_SHUYAKU_KBN_COMPANY_NAME = '会社一括';
  public static readonly C_SHUYAKU_KBN_SITEN = '2'; // 支店毎
  public static readonly C_SHUYAKU_KBN_SITEN_NAME = '支店毎';

  /**初期化フラグ*/
  public static readonly C_RESET_FLG_ON = '1'; // 初期化する
  public static readonly C_RESET_FLG_OFF = '0'; // 初期化する

  /**有り/無し  区分*/
  public static readonly C_KBN_ARI = '1';
  public static readonly C_KBN_NASHI = '0';
  /**有り/無し和名*/
  public static readonly C_KBN_ARI_NAME = '有り';
  public static readonly C_KBN_NASHI_NAME = '無し';

  /**同意有無  区分*/
  public static readonly C_KBN_DOUI_ARI = '1';
  public static readonly C_KBN_DOUI_HOSHO = '2';
  /**同意有無  和名*/
  public static readonly C_KBN_DOUI_ARI_NAME = '同意書面有りのみ保証';
  public static readonly C_KBN_DOUI_HOSHO_NAME = '同意書面の有無に関わらず保証';

  /** 保証料  区分 */
  public static readonly C_KBN_HOSHORYO_GETSUGAKU = '1';
  public static readonly C_KBN_HOSHORYO_KEIZOKU = '2';
  public static readonly C_KBN_HOSHORYO_SHIHARAI_TESURYO = '3';

  /** G条件_適用区分 */
  public static readonly C_G_KBN_SHIHARAI = '1'; // 支払委託
  public static readonly C_G_KBN_JISHA = '2'; // 自社保証
  public static readonly C_G_KBN_NASHI = '0'; // 無し

  public static readonly C_G_TEKIGO_FLG_NASHI = '0'; // G条件適合フラグ：0(無)
  public static readonly C_G_TEKIGO_FLG_TEKIGO = '1'; // G条件適合フラグ：1(適合)
  public static readonly C_G_SHOKAI_HOSHO_FLG_ARI = '1'; // G条件_初回保証料上乗せ負フラグ：1(上乗せする)

  /**原状回復_延滞有無  区分*/
  public static readonly C_GEN_ENTAI_ARI = '1';
  public static readonly C_GEN_ENTAI_HOSHO = '2';
  /**原状回復_延滞有無  和名*/
  public static readonly C_GEN_ENTAI_ARI_NAME = '有りのみ保証';
  public static readonly C_GEN_ENTAI_HOSHO_NAME = '有無に関わらず保証';

  /**違約金保証_延滞有無  区分*/
  public static readonly C_IYAKU_ENTAI_HOSHO = '1';
  public static readonly C_IYAKU_ENTAI_ARI = '2';
  /**違約金保証_延滞有無  和名*/
  public static readonly C_IYAKU_ENTAI_HOSHO_NAME = '延滞無しでも保証';
  public static readonly C_IYAKU_ENTAI_ARI_NAME = '延滞有りのみ保証';

  /**可/不可  区分*/
  public static readonly C_KBN_KA = '1';
  public static readonly C_KBN_FUKA = '0';
  /**可/不可  和名*/
  public static readonly C_KBN_KA_NAME = '可';
  public static readonly C_KBN_FUKA_NAME = '不可';

  /**料率/定額/無し  区分*/
  public static readonly C_SHOHIN_KBN_RATE = '1';
  public static readonly C_SHOHIN_KBN_TEIGAKU = '2';
  public static readonly C_SHOHIN_KBN_NASHI = '0';
  /**料率/定額/無し  和名*/
  public static readonly C_SHOHIN_KBN_RATE_NAME = '料率';
  public static readonly C_SHOHIN_KBN_TEIGAKU_NAME = '定額';
  public static readonly C_SHOHIN_KBN_NASHI_NAME = '無し';

  /**収納代行有無 0:無 1:有*/
  public static readonly C_SHUNOUDAIKOU_UMU_MU = '0';
  public static readonly C_SHUNOUDAIKOU_UMU_MU_NAME = '無';
  public static readonly C_SHUNOUDAIKOU_UMU_U = '1';
  public static readonly C_SHUNOUDAIKOU_UMU_U_NAME = '有';

  /**出金ステータス	0:引当中 1:未 2:依頼中 3:出金済み 4:出金NG 5:不要*/
  public static readonly C_SHUKKIN_STS_HIKI = '0';
  public static readonly C_SHUKKIN_STS_HIKI_NAME = '引当中';
  public static readonly C_SHUKKIN_STS_MI = '1';
  public static readonly C_SHUKKIN_STS_MI_NAME = '未';
  public static readonly C_SHUKKIN_STS_IRAITYU = '2';
  public static readonly C_SHUKKIN_STS_IRAITYU_NAME = '依頼中';
  public static readonly C_SHUKKIN_STS_SHUKKINSUMI = '3';
  public static readonly C_SHUKKIN_STS_SHUKKINSUMI_NAME = '出金済み';
  public static readonly C_SHUKKIN_STS_SHUKKINNG = '4';
  public static readonly C_SHUKKIN_STS_SHUKKINNG_NAME = '出金NG';
  public static readonly C_SHUKKIN_STS_FUYOU = '5';
  public static readonly C_SHUKKIN_STS_FUYOU_NAME = '不要';

  /**入居者区分*/
  public static readonly C_NYUKYOSHA_KBN_MOUSHIKOMISHA = '1';
  public static readonly C_NYUKYOSHA_KBN_MOUSHIKOMISHA_NAME = '申込者のみ';
  public static readonly C_NYUKYOSHA_KBN_MOUSHIKOMISHA_AND_FAMILY = '2';
  public static readonly C_NYUKYOSHA_KBN_MOUSHIKOMISHA_AND_FAMILY_NAME = '申込者と同居人';
  public static readonly C_NYUKYOSHA_KBN_FAMILY = '3';
  public static readonly C_NYUKYOSHA_KBN_FAMILY_NAME = '申込者以外';
  public static readonly C_NYUKYOSHA_KBN_DAIHYOSHA = '4';
  public static readonly C_NYUKYOSHA_KBN_DAIHYOSHA_NAME = '代表者';
  public static readonly C_NYUKYOSHA_KBN_DAIHYOSHA_AND_FAMILY = '5';
  public static readonly C_NYUKYOSHA_KBN_DAIHYOSHA_AND_FAMILY_NAME = '代表者および家族';
  public static readonly C_NYUKYOSHA_KBN_EMPLOYEE = '6';
  public static readonly C_NYUKYOSHA_KBN_EMPLOYEE_NAME = '社員';
  public static readonly C_NYUKYOSHA_KBN_EMPLOYEE_AND_FAMILY = '7';
  public static readonly C_NYUKYOSHA_KBN_EMPLOYEE_AND_FAMILY_NAME = '社員および家族';
  public static readonly C_NYUKYOSHA_KBN_OTHER = 'Z';
  public static readonly C_NYUKYOSHA_KBN_OTHER_NAME = 'その他';

  /**仲介フラグ*/
  public static readonly C_CHUKAI_FLG_ARI = '1';
  public static readonly C_CHUKAI_FLG_ARI_NAME = '有';
  public static readonly C_CHUKAI_FLG_NASI = '0';
  public static readonly C_CHUKAI_FLG_NASI_NAME = '無';

  /**表示フラグ  区分*/
  public static readonly C_KBN_HYOJI_ARI = '1';
  /**表示フラグ  和名*/
  public static readonly C_KBN_HYOJI_ARI_NAME = '○';

  /**請求先  区分*/
  public static readonly C_KBN_SEIKYU_KANRI = '1';
  public static readonly C_KBN_SEIKYU_TENANT = '2';
  /**請求先  和名*/
  public static readonly C_KBN_SEIKYU_KANRI_NAME = '管理';
  public static readonly C_KBN_SEIKYU_TENANT_NAME = 'ﾃﾅﾝﾄ';

  /**有効期限(有効/無効)*/
  public static readonly EXPIRY_DATE_KBN_INVALID_NAME = '無効';
  public static readonly EXPIRY_DATE_KBN_VALID_NAME = '有効';

  /**ローマ数字*/
  public static readonly C_ROMAN_NUMBER_UPPER_I = 'Ⅰ';
  public static readonly C_ROMAN_NUMBER_UPPER_II = 'Ⅱ';
  public static readonly C_ROMAN_NUMBER_UPPER_III = 'Ⅲ';
  public static readonly C_ROMAN_NUMBER_UPPER_IV = 'Ⅳ';
  public static readonly C_ROMAN_NUMBER_UPPER_V = 'Ⅴ';
  public static readonly C_ROMAN_NUMBER_UPPER_VI = 'Ⅵ';
  public static readonly C_ROMAN_NUMBER_UPPER_VII = 'Ⅶ';
  public static readonly C_ROMAN_NUMBER_UPPER_VIII = 'Ⅷ';
  public static readonly C_ROMAN_NUMBER_UPPER_IX = 'Ⅸ';
  public static readonly C_ROMAN_NUMBER_UPPER_X = 'Ⅹ';
  public static readonly C_ROMAN_NUMBER_UPPER_XI = 'Ⅺ';
  public static readonly C_ROMAN_NUMBER_UPPER_XII = 'Ⅻ';

  public static readonly C_ROMAN_NUMBER_LOWER_I = 'ⅰ';
  public static readonly C_ROMAN_NUMBER_LOWER_II = 'ⅱ';
  public static readonly C_ROMAN_NUMBER_LOWER_III = 'ⅲ';
  public static readonly C_ROMAN_NUMBER_LOWER_IV = 'ⅳ';
  public static readonly C_ROMAN_NUMBER_LOWER_V = 'ⅴ';
  public static readonly C_ROMAN_NUMBER_LOWER_VI = 'ⅵ';
  public static readonly C_ROMAN_NUMBER_LOWER_VII = 'ⅶ';
  public static readonly C_ROMAN_NUMBER_LOWER_VIII = 'ⅷ';
  public static readonly C_ROMAN_NUMBER_LOWER_IX = 'ⅸ';
  public static readonly C_ROMAN_NUMBER_LOWER_X = 'ⅹ';
  public static readonly C_ROMAN_NUMBER_LOWER_XI = 'ⅺ';
  public static readonly C_ROMAN_NUMBER_LOWER_XII = 'ⅻ';

  /**アラビア数字*/
  public static readonly C_ARABIC_NUMBER_1 = '１';
  public static readonly C_ARABIC_NUMBER_2 = '２';
  public static readonly C_ARABIC_NUMBER_3 = '３';
  public static readonly C_ARABIC_NUMBER_4 = '４';
  public static readonly C_ARABIC_NUMBER_5 = '５';
  public static readonly C_ARABIC_NUMBER_6 = '６';
  public static readonly C_ARABIC_NUMBER_7 = '７';
  public static readonly C_ARABIC_NUMBER_8 = '８';
  public static readonly C_ARABIC_NUMBER_9 = '９';
  public static readonly C_ARABIC_NUMBER_10 = '１０';
  public static readonly C_ARABIC_NUMBER_11 = '１１';
  public static readonly C_ARABIC_NUMBER_12 = '１２';

  /**バーチャル口座種別区分*/
  public static readonly C_VKOZASHBT_NYUKIN = 1;
  public static readonly C_VKOZASHBT_SHUKIN = 2;
  public static readonly C_VKOZASHBT_RENTAI = 3;

  /**金融機関コード*/
  public static readonly C_BANK_CODE_BTMU = '0005'; // BTMU
  public static readonly C_BANK_CODE_SMBC = '0009'; // SMBTC
  public static readonly C_BANK_CODE_MIZUHO = '0001'; // みずほ
  public static readonly C_BANK_CODE_MIZUHOCORP = '0016'; // みずほコーポレーション

  /**送金収納会社*/
  public static readonly C_SOUKIN_COMPANY_BTMU = '004'; // BTMU
  public static readonly C_SOUKIN_COMPANY_BTMU_NAME = 'BTMU';
  public static readonly C_SOUKIN_COMPANY_SMBC = '005'; // SMBC
  public static readonly C_SOUKIN_COMPANY_SMBC_NAME = 'SMBC';
  public static readonly C_SOUKIN_COMPANY_MIZUHO = '006'; // みずほ
  public static readonly C_SOUKIN_COMPANY_MIZUHO_NAME = 'みずほ';
  /**取込みタイミング名*/
  public static readonly C_TIMING_AM = '午前';
  public static readonly C_TIMING_NOON = '正午';
  public static readonly C_TIMING_PM = '午後';
  public static readonly C_TIMING_EVENING = '夕方';
  public static readonly C_TIMING_NIGHT = '夜';
  public static readonly C_TIMING_ALL = 'ALL';

  public static readonly C_TIMING_THRESHOLD_AM = '11:00:00';
  public static readonly C_TIMING_THRESHOLD_NOON = '13:30:00';
  public static readonly C_TIMING_THRESHOLD_PM = '15:30:00';
  public static readonly C_TIMING_THRESHOLD_EVENING = '16:30:00';
  public static readonly C_TIMING_THRESHOLD_NIGHT = '18:00:00';
  public static readonly C_TIMING_FORMAT_HHMMSS = 'hh:mm:ss';

  public static readonly C_TIMING_ID_AM = '1';
  public static readonly C_TIMING_ID_NOON = '2';
  public static readonly C_TIMING_ID_PM = '3';
  public static readonly C_TIMING_ID_EVENING = '4';
  public static readonly C_TIMING_ID_NIGHT = '6';
  public static readonly C_TIMING_ID_ALL = '5';

  /** 引用符 */
  public static readonly QUOTES = '"';

  public static readonly C_ATENA_OUTPUT_KBN_TANAKO = '1';
  public static readonly C_ATENA_OUTPUT_KBN_OOYA = '2';

  /**送金区分*/
  public static readonly C_SOUKIN_KBN_NONE = '000'; // なし
  public static readonly C_SOUKIN_KBN_27MAE = '001'; // ２７日(前)
  public static readonly C_SOUKIN_KBN_27MAE_NAME = '２７日(前)';
  public static readonly C_SOUKIN_KBN_27MAE_FILE_NAME = '27MAE';
  public static readonly C_SOUKIN_KBN_27ATO = '002'; //２７日(後)
  public static readonly C_SOUKIN_KBN_27ATO_NAME = '２７日(後)';
  public static readonly C_SOUKIN_KBN_27ATO_FILE_NAME = '27ATO';
  public static readonly C_SOUKIN_KBN_MATSU = '003'; // 末日
  public static readonly C_SOUKIN_KBN_MATSU_NAME = '末日';
  public static readonly C_SOUKIN_KBN_MATSU_FILE_NAME = 'MATSU';
  public static readonly C_SOUKIN_KBN_25MAE = '006'; // ２５日(前)
  public static readonly C_SOUKIN_KBN_25MAE_NAME = '２５日(前)';
  public static readonly C_SOUKIN_KBN_25MAE_FILE_NAME = '25MAE';
  public static readonly C_SOUKIN_KBN_25ATO = '007'; // ２５日(後)
  public static readonly C_SOUKIN_KBN_25ATO_NAME = '２５日(後)';
  public static readonly C_SOUKIN_KBN_25ATO_FILE_NAME = '25ATO';
  public static readonly C_SOUKIN_KBN_20MAE = '008'; // ２０日(前)
  public static readonly C_SOUKIN_KBN_20MAE_NAME = '２０日(前)';
  public static readonly C_SOUKIN_KBN_20MAE_FILE_NAME = '20MAE';
  public static readonly C_SOUKIN_KBN_20ATO = '009'; // ２０日(後)
  public static readonly C_SOUKIN_KBN_20ATO_NAME = '２０日(後)';
  public static readonly C_SOUKIN_KBN_20ATO_FILE_NAME = '20ATO';
  public static readonly C_SOUKIN_KBN_15 = '010'; // １５日
  public static readonly C_SOUKIN_KBN_15_NAME = '１５日';
  public static readonly C_SOUKIN_KBN_15_FILE_NAME = '15';

  /** 時間フォーマット(YYMMDD) */
  public static readonly DATE_FORMAT_YYMMDD = 'YYMMDD';
  /** 時間フォーマット(YY-MM-DD) */
  public static readonly DATE_FORMAT_YYMMDD_HYPHEN = 'YY-MM-DD';
  /** 時間フォーマット(YY/MM/DD) */
  public static readonly DATE_FORMAT_YYMMDD_SLASH = 'YY/MM/DD';
  /** 時間フォーマット(YY年MM月DD日) */
  public static readonly DATE_FORMAT_YYMMDD_JP = 'YY年MM月DD日';
  /** 時間フォーマット(YYYY/MM/DD) */
  public static readonly DATE_FORMAT_YYYYMMDD_JP = 'YYYY/MM/DD';

  /** 空白→0変換 */
  public static readonly C_EMPTY_TO_ZERO = '0';

  // 定数
  // lblMsgのフォントサイズ
  public static readonly C_LABEL_MESSAGE_SIZE = 10;

  // R社内定義情報
  // ダミー口座ID(カンマ区切り。文字列の前後を必ず","で囲むこと)
  public static readonly C_HIKIOTOSHI_DUMMY_KOZA_ID = ',2466,2114,145428,77082,';
  // 入金（契約者口座（口座ID））ダミー口座ID
  public static readonly C_NYUKIN_DUMMY_KOZA_ID = new Decimal(2114);

  // Accessアクション名
  public static readonly C_ACCESS_ACTION_TABLE = 'TABLE';
  public static readonly C_ACCESS_ACTION_QUERY = 'QUERY';
  public static readonly C_ACCESS_ACTION_FORM = 'FORM';
  public static readonly C_ACCESS_ACTION_REPORT = 'REPORT';
  public static readonly C_ACCESS_ACTION_MACRO = 'MACRO';
  public static readonly C_ACCESS_ACTION_VBA = 'VBA';

  // 外部接続ファイル出力区分
  public static readonly C_FILE_KBN_OUTPUT_OK = '1'; // データ出力有
  public static readonly C_FILE_KBN_OUTPUT_NG = '2'; // データ出力無
  // 振込人名区分
  public static readonly FURIKOMININ_TENANT_PLUS_RFI = '1'; // 「賃借人名」＋リクルートフォレントインシュア
  public static readonly FURIKOMININ_TENANT = '2'; // 賃借人名
  public static readonly FURIKOMININ_RFI = '3'; // リクルートフォレントインシュア
  // 出力対象区分
  public static readonly C_FILE_TAISHO_SHUNO_MISHU = '1';
  public static readonly C_FILE_TAISHO_MISHU = '2';
  // 未着書類リスト出力対象区分
  public static readonly C_Output_KBN_ON = '1'; // 出力有
  public static readonly C_Output_KBN_OFF = '2'; // 出力無
  // 送金区分
  public static readonly C_SOUKIN_KBN_NASI = '000'; // なし
  // 送金会社収納種別
  public static readonly SOUKIN_SHUNOU_COMPANY_SHBT_NASI = '000';

  // 月額請求書発送区分
  public static readonly C_SEIKYU_HASSO_NASHI = '0'; // 発送無し
  public static readonly C_SEIKYU_HASSO_HAGAKI = '1'; // ハガキ発送
  public static readonly C_SEIKYU_HASSO_SMS = '2'; // SMS送信
  // 前家賃区分
  public static readonly C_MAEYACHIN_KBN_YOKUGETSU = '1'; // 翌月
  public static readonly C_MAEYACHIN_KBN_YOKUYOKUGETSU = '2'; // 翌々月
  public static readonly C_MAEYACHIN_KBN_MISHITEI = '3'; // 未指定

  // R社子画面
  // 呼び出し元種別
  public static readonly CALL_FORM = {
    FUDOSAN: 1, // 不動産会社支店情報登録変更画面
    KEIYAKU: 2, // 審査契約情報登録変更画面
    FUDOSAN_HONSHA: 3, // 不動産会社登録変更画面
  };
  // バーチャル口座種別
  public static readonly VKOZASHBT = {
    REAL: 0,
    NYUKIN: 1,
    SHUKIN: 2,
    RENTAI: 3,
  };

  // 共通
  // 登録確認区分
  public static readonly ENTRY_FLG_CONFIRM = true; // 登録確認
  public static readonly ENTRY_FLG_INPUT = false; // 項目入力中
  // 登録/変更区分
  public static readonly MODE_ENTRY = '1'; // 新規登録
  public static readonly MODE_CHANGE = '2'; // 変更
  // フラグ
  public static readonly FLG_ON = '1'; // ON
  public static readonly FLG_OFF = '0'; // OFF
  // 削除フラグ
  public static readonly DEL_FLG_TRUE = '1'; // 削除有
  public static readonly DEL_FLG_FALSE = '0'; // 削除無

  // 明細書式コード初期設定値
  public static readonly DEFAULT_MEISAI_SHOSHIKI_CODE_HOSHORYO = 'F21'; // 連帯保証料
  public static readonly DEFAULT_MEISAI_SHOSHIKI_CODE_TESURYO = 'F31'; // 代理店手数料
  public static readonly DEFAULT_MEISAI_SHOSHIKI_CODE_YACHIN = 'F01'; // 家賃振込
  public static readonly DEFAULT_MEISAI_SHOSHIKI_CODE_REPORT = 'F11'; // 収納状況レポート
  // 延滞利息猶予期間
  public static readonly C_ENTAI_RISOKU_YUYO_KIKAN = 0;
  // 延滞利息利率
  public static readonly C_RIRITU = 14.6;

  // 万円系数値項目桁数チェック用定数
  public static readonly C_MAN_YEN_ITEM_INT_SIZE = 6; // 整数部桁数
  public static readonly C_MAN_YEN_ITEM_DEC_SIZE = 4; // 小数部桁数

  // 物件
  // 物件区分
  public static readonly BUKKEN_KBN_BUKKEN = '1'; // 建物
  public static readonly BUKKEN_KBN_BUKKEN_NAME = '建物';
  public static readonly BUKKEN_KBN_PARKING = '2'; // 駐車場
  public static readonly BUKKEN_KBN_PARKING_NAME = '駐車場';

  // 振込用紙（CVS収納）送付先区分
  public static readonly CVS_SOUFUSAKI_KBN_TANAKO = '1'; // 未
  public static readonly CVS_SOUFUSAKI_KBN_TANAKO_NAME = '契約者';
  public static readonly CVS_SOUFUSAKI_KBN_BUKKEN = '2'; // 完
  public static readonly CVS_SOUFUSAKI_KBN_BUKKEN_NAME = '物件';
  public static readonly CVS_SOUFUSAKI_KBN_OTHER = '3'; // 完
  public static readonly CVS_SOUFUSAKI_KBN_OTHER_NAME = 'その他';

  // 家賃出納区分フラグ
  public static readonly C_YATIN_SUITOU_KBN_HIKI = '1'; // 引落
  public static readonly C_YATIN_SUITOU_KBN_HIKI_NAME = '引落';
  public static readonly C_YATIN_SUITOU_KBN_FURI = '2'; // 振込
  public static readonly C_YATIN_SUITOU_KBN_FURI_NAME = '振込';
  public static readonly C_YATIN_SUITOU_KBN_K_FURI = '3'; // 振込
  public static readonly C_YATIN_SUITOU_KBN_K_FURI_NAME = '個別振込';

  // 定期借家／普通借家区分
  public static readonly C_SHAKUYA_KBN_FUTSU = '1';
  public static readonly C_SHAKUYA_KBN_FUTSU_NAME = '普通借家';
  public static readonly C_SHAKUYA_KBN_TEIKI = '2';
  public static readonly C_SHAKUYA_KBN_TEIKI_NAME = '定期借家';
  // 入居者家族構成
  public static readonly C_NYUKYOSHA_MISENTAKU = '00'; // 00:未選択
  public static readonly C_NYUKYOSHA_SINGLE = '01'; // 01:独身
  public static readonly C_NYUKYOSHA_SINGLE_WITH_KIDS = '02'; // 02:独身（子供有り）
  public static readonly C_NYUKYOSHA_MARRIED = '03'; // 03:配偶者有り
  public static readonly C_NYUKYOSHA_TANSHIN = '04'; // 04:単身
  public static readonly C_NYUKYOSHA_OTHER = '99'; // 99:その他
  // 入居/転居理由
  public static readonly C_NYUKYO_REASON_MISENTAKU = '00'; // 00:未選択
  public static readonly C_NYUKYO_REASON_KOJIN_MARRIAGE = '01'; // 01:結婚(個人)
  public static readonly C_NYUKYO_REASON_KOJIN_DOKURITSU = '02'; // 02:独立(個人)
  public static readonly C_NYUKYO_REASON_KOJIN_SHUSHOKU = '03'; // 03:就職/入学(個人)
  public static readonly C_NYUKYO_REASON_KOJIN_TENKIN = '04'; // 04:転勤(個人)
  public static readonly C_NYUKYO_REASON_KOJIN_TENSHOKU = '05'; // 05:転職(個人)
  public static readonly C_NYUKYO_REASON_KOJIN_TSUKIN_JIKAN = '06'; // 06:通勤時間(個人)
  public static readonly C_NYUKYO_REASON_KOJIN_TEZEMA = '07'; // 07:手狭(個人)
  public static readonly C_NYUKYO_REASON_KOJIN_YACHIN = '08'; // 08:家賃が高い(個人)
  public static readonly C_NYUKYO_REASON_KOJIN_KANKYO = '09'; // 09:環境(個人)
  public static readonly C_NYUKYO_REASON_HOJIN_SHATAKU = '10'; // 10:社宅(法人)
  public static readonly C_NYUKYO_REASON_HOJIN_TENKIN = '11'; // 11:転勤(法人)
  public static readonly C_NYUKYO_REASON_HOJIN_KAKUDAI = '12'; // 12:事業拡大のため(法人)
  public static readonly C_NYUKYO_REASON_HOJIN_RICCHI = '13'; // 13:立地・環境(法人)
  public static readonly C_NYUKYO_REASON_HOJIN_TEZEMA = '14'; // 14:手狭(法人)
  public static readonly C_NYUKYO_REASON_HOJIN_CHINRYO = '15'; // 15:賃料(法人)
  public static readonly C_NYUKYO_REASON_OTHER = '99'; // 99:その他

  // 事業内容
  public static readonly C_JIGYOU_MISENTAKU = '00'; // 未選択
  public static readonly C_JIGYOU_BANK = '01'; // 金融機関
  public static readonly C_JIGYOU_FUDOUSAN = '02'; // 不動産
  public static readonly C_JIGYOU_KENCHIKU = '03'; // 建築/工事
  public static readonly C_JIGYOU_SEIZOU = '04'; // 製造
  public static readonly C_JIGYOU_IT = '05'; // IT関連
  public static readonly C_JIGYOU_KOUKOKU = '06'; // 広告
  public static readonly C_JIGYOU_KOURI = '07'; // 小売/サービス
  public static readonly C_JIGYOU_RIKUUN = '08'; // 陸運
  public static readonly C_JIGYOU_KYOUIKU = '09'; // 教育
  public static readonly C_JIGYOU_IRYOU = '10'; // 医療機関
  public static readonly C_JIGYOU_OTHER = '99'; // その他
  // 業種区分
  public static readonly C_GYOSHU_MISENTAKU = '00'; // 未選択
  public static readonly C_GYOSHU_BANK = '01'; // 金融機関
  public static readonly C_GYOSHU_FUDOUSAN = '02'; // 不動産
  public static readonly C_GYOSHU_KENCHIKU = '03'; // 建築/工事
  public static readonly C_GYOSHU_SEIZOU = '04'; // 製造
  public static readonly C_GYOSHU_IT = '05'; // IT関連
  public static readonly C_GYOSHU_KOUKOKU = '06'; // 広告
  public static readonly C_GYOSHU_KOURI = '07'; // 小売/サービス
  public static readonly C_GYOSHU_RIKUUN = '08'; // 陸運
  public static readonly C_GYOSHU_KYOUIKU = '09'; // 教育
  public static readonly C_GYOSHU_IRYOU = '10'; // 医療機関
  public static readonly C_GYOSHU_OTHER = '99'; // その他
  // 職種
  public static readonly C_SHOKUSHU_MISENTAKU = '0'; // 未選択
  public static readonly C_SHOKUSHU_MISENTAKU_NAME = '未選択';
  public static readonly C_SHOKUSHU_KAISHAIN = '1'; // 会社員
  public static readonly C_SHOKUSHU_KAISHAIN_NAME = '会社員';
  public static readonly C_SHOKUSHU_KEIYAKU = '2'; // 契約社員"
  public static readonly C_SHOKUSHU_KEIYAKU_NAME = '契約社員';
  public static readonly C_SHOKUSHU_KOMUIN = '3'; // 公務員
  public static readonly C_SHOKUSHU_KOMUIN_NAME = '公務員';
  public static readonly C_SHOKUSHU_JIEIGYO = '4'; // 自営業
  public static readonly C_SHOKUSHU_JIEIGYO_NAME = '自営業';
  public static readonly C_SHOKUSHU_PART = '5'; // パート/アルバイト
  public static readonly C_SHOKUSHU_PART_NAME = 'パート/アルバイト';
  public static readonly C_SHOKUSHU_GAKUSEI = '6'; // 学生
  public static readonly C_SHOKUSHU_GAKUSEI_NAME = '学生'; // 学生
  public static readonly C_SHOKUSHU_NENKIN = '7'; // 年金が主な収入
  public static readonly C_SHOKUSHU_NENKIN_NAME = '年金が主な収入';
  public static readonly C_SHOKUSHU_SEIKATSUHOGO = '8'; // 生活保護受給
  public static readonly C_SHOKUSHU_SEIKATSUHOGO_NAME = '生活保護受給';
  public static readonly C_SHOKUSHU_MUSHOKU = '9'; // 無職
  public static readonly C_SHOKUSHU_MUSHOKU_NAME = '無職';
  public static readonly C_SHOKUSHU_HAKEN = 'A'; // 派遣社員
  public static readonly C_SHOKUSHU_HAKEN_NAME = '派遣社員';
  public static readonly C_SHOKUSHU_OTHER = 'Z'; // その他
  public static readonly C_SHOKUSHU_OTHER_NAME = 'その他';
  // 負担金分割区分
  public static readonly C_FUTANKIN_BUNKATU_KBN_NASHI = '1';
  public static readonly C_FUTANKIN_BUNKATU_KBN_NASHI_NAME = '分割しない';
  public static readonly C_FUTANKIN_BUNKATU_KBN_ARI = '2';
  public static readonly C_FUTANKIN_BUNKATU_KBN_ARI_NAME = '分割する';
  // 取扱手数料(代理店手数料)<振込ステータス>
  public static readonly C_TORIATSUKAI_TESURYO_MI = '1'; // 未
  public static readonly C_TORIATSUKAI_TESURYO_MI_NAME = '未';
  public static readonly C_TORIATSUKAI_TESURYO_IRAICHU = '2'; // 依頼中
  public static readonly C_TORIATSUKAI_TESURYO_IRAICHU_NAME = '依頼中';
  public static readonly C_TORIATSUKAI_TESURYO_FURIKOMI_SUMI = '3'; // 振込済み
  public static readonly C_TORIATSUKAI_TESURYO_FURIKOMI_SUMI_NAME = '振込済み';
  public static readonly C_TORIATSUKAI_TESURYO_FURIKOMI_NG = '4'; // 振込NG
  public static readonly C_TORIATSUKAI_TESURYO_FURIKOMI_NG_NAME = '振込NG';
  public static readonly C_TORIATSUKAI_TESURYO_FURIKOMI_UNNECESSARY = '5'; // 振込不要
  public static readonly C_TORIATSUKAI_TESURYO_FURIKOMI_UNNECESSARY_NAME = '振込不要';
  // 連帯保証料<入金ステータス>
  public static readonly C_RENTAI_HOSHORYO_HIKIATECHU = '0'; // 引当中
  public static readonly C_RENTAI_HOSHORYO_HIKIATECHU_NAME = '引当中';
  public static readonly C_RENTAI_HOSHORYO_MI = '1'; // 未
  public static readonly C_RENTAI_HOSHORYO_MI_NAME = '未';
  public static readonly C_RENTAI_HOSHORYO_IRAICHU = '2'; // 依頼中
  public static readonly C_RENTAI_HOSHORYO_IRAICHU_NAME = '依頼中';
  public static readonly C_RENTAI_HOSHORYO_NYUKIN_SUMI = '3'; // 入金済み
  public static readonly C_RENTAI_HOSHORYO_NYUKIN_SUMI_NAME = '入金済み';
  public static readonly C_RENTAI_HOSHORYO_NYUKIN_UNNECESSARY = '4'; // 入金不要
  public static readonly C_RENTAI_HOSHORYO_NYUKIN_UNNECESSARY_NAME = '入金不要';

  // スーパー賃貸
  public static readonly C_SUPER_TINTAI_NASI = '0';
  public static readonly C_SUPER_TINTAI_NASI_NAME = '無';
  public static readonly C_SUPER_TINTAI_ARI = '1';
  public static readonly C_SUPER_TINTAI_ARI_NAME = '有';
  // 包括案件
  public static readonly C_HOUKATU_ANKEN_NASI = '0';
  public static readonly C_HOUKATU_ANKEN_NASI_NAME = '無';
  public static readonly C_HOUKATU_ANKEN_ARI = '1';
  public static readonly C_HOUKATU_ANKEN_ARI_NAME = '有';

  // 与信情報(個人)
  // 住居種類
  public static readonly C_JYUKYO_SHURUI_MISENTAKU = '0'; // 未選択
  public static readonly C_JYUKYO_SHURUI_TINTAI = '1'; // 賃貸
  public static readonly C_JYUKYO_SHURUI_KAZOKUSYOYU = '2'; // 家族所有
  public static readonly C_JYUKYO_SHURUI_SYATAKURYO = '3'; // 社宅・寮
  public static readonly C_JYUKYO_SHURUI_KOEIJYUTAKU = '4'; // 公営住宅
  public static readonly C_JYUKYO_SHURUI_ZIKOSYOYU = '5'; // 自己所有
  public static readonly C_JYUKYO_SHURUI_SONOTA = '6'; // その他
  // 現住居の連帯保証人
  public static readonly C_HOSHO_NIN_MISENTAKU = '0'; // 未選択
  public static readonly C_HOSHO_NIN_OYA = '1'; // 親
  public static readonly C_HOSHO_NIN_KYODAI = '2'; // 兄弟
  public static readonly C_HOSHO_NIN_SHINZOKU = '3'; // 親族
  public static readonly C_HOSHO_NIN_HAIGUSYA = '4'; // 配偶者
  public static readonly C_HOSHO_NIN_YUZINTIZIN = '5'; // 友人・知人
  public static readonly C_HOSHO_NIN_HOSHOKAISYA = '6'; // 保証会社
  public static readonly C_HOSHO_NIN_SONOTA = '7'; // その他
  // 設問
  public static readonly C_YOSHIN_SETUMON_YES = '1'; // YES
  public static readonly C_YOSHIN_SETUMON_NO = '0'; // NO
  public static readonly C_YOSHIN_SETUMON_UNKNOWN = '9'; // 未記入
  // 国籍区分
  public static readonly C_KOKUSEKI_JAPANESE = '1'; // 日本人
  public static readonly C_KOKUSEKI_FOREIGNER = '2'; // 日本人以外
  public static readonly C_KOKUSEKI_UNKNOWN = '9'; // 未記入
  // 本人確認書類_INDEX
  public static readonly C_HONNIN_KAKUNIN_MISENTAKU_CODE = 0; // 未選択
  public static readonly C_HONNIN_KAKUNIN_MENKYOSHO_CODE = 1; // 運転免許証
  public static readonly C_HONNIN_KAKUNIN_HOKENSHO_CODE = 2; // 保険証
  public static readonly C_HONNIN_KAKUNIN_PASSPORT_CODE = 3; // パスポート
  public static readonly C_HONNIN_KAKUNIN_NENKIN_TECHO_CODE = 4; // 年金手帳
  public static readonly C_HONNIN_KAKUNIN_GAIKOKUJIN_TOUROKUSHO_CODE = 5; // 外国人登録証明証
  public static readonly C_HONNIN_KAKUNIN_SONOTA_CODE = 6; // その他
  // 本人確認書類_値
  public static readonly C_HONNIN_KAKUNIN_MISENTAKU = '0'; // 未選択
  public static readonly C_HONNIN_KAKUNIN_MENKYOSHO = '1'; // 運転免許証
  public static readonly C_HONNIN_KAKUNIN_HOKENSHO = '2'; // 保険証
  public static readonly C_HONNIN_KAKUNIN_PASSPORT = '3'; // パスポート
  public static readonly C_HONNIN_KAKUNIN_NENKIN_TECHO = '4'; // 年金手帳
  public static readonly C_HONNIN_KAKUNIN_GAIKOKUJIN_TOUROKUSHO = '5'; // 外国人登録証明証
  public static readonly C_HONNIN_KAKUNIN_SONOTA = '6'; // その他

  // 与信情報(法人)
  // 上場有無
  public static readonly C_JOJO_U = '1'; // 上場
  public static readonly C_JOJO_MU = '2'; // 非上場
  public static readonly C_JOJO_UNKNOWN = '9'; // 未入力

  // 契約情報取得クラス
  public static readonly C_GET_KEIYAKU_KBN_NONE = 0; // 0件取得
  public static readonly C_GET_KEIYAKU_KBN_MULTI = -1; // 複数件取得

  // XML読取り
  // 必須区分区分
  public static readonly REQUIRED_KBN = {
    None: 0, // 未必須
    Tag: 1, // タグ必須
    Value: 2, // 値必須
  };
  // XMLルートタグ名称
  public static readonly C_XML_ROOT_TAG = 'Setting';
  // XML配列格納用タグ名称
  public static readonly C_XML_ARRAY_TAG_ITEM = 'item';
  // XMLフォルダパス
  public static readonly C_XML_SENDERINFO_FOLDER = 'localPrint';
  // 差出人XMLファイル
  public static readonly C_SENDERINFO_XML_FILE = '\\SenderInfo.xml';
  // 差出人XMLタグ
  public static readonly C_XML_SENDERINFO_ITEM_TAG = 'Item';
  public static readonly C_XML_SENDERINFO_ZIP_TAG = 'ZipCode';
  public static readonly C_XML_SENDERINFO_ADDRESS1_TAG = 'Address1';
  public static readonly C_XML_SENDERINFO_ADDRESS2_TAG = 'Address2';
  public static readonly C_XML_SENDERINFO_COMPANY_INFO_TAG = 'CompanyInfo';
  public static readonly C_XML_SENDERINFO_BUSINESSTIME_TAG = 'BusinessTime';
  public static readonly C_XML_SENDERINFO_COMPANY_NAME_TAG = 'CompanyName';

  // CTI
  public static readonly C_MAIN_THREAD_NAME = 'Main';

  // カード回収状況
  public static readonly CARD_KAISHU_JOKYO_NULL = 0; // 空欄
  public static readonly CARD_KAISHU_JOKYO_NULL_NAME = '';
  public static readonly CARD_KAISHU_JOKYO_RIYOUCHU_INDEX = 1;
  public static readonly CARD_KAISHU_JOKYO_MIKAISHU_INDEX = 2;
  public static readonly CARD_KAISHU_JOKYO_KAISHUZUMI_INDEX = 3;
  // 宅建資格有無
  public static readonly C_TAKKEN_SIKAKU_FLG_OFF = '0';
  public static readonly C_TAKKEN_SIKAKU_FLG_OFF_NAME = '無';
  public static readonly C_TAKKEN_SIKAKU_FLG_ON = '1';
  public static readonly C_TAKKEN_SIKAKU_FLG_ON_NAME = '有';

  // 登録区分
  public static readonly C_TOUROKU_KBN_KEIYAKU_INFO = '1';
  public static readonly C_TOUROKU_KBN_KEIYAKU_INFO_NAME = '契約時情報';
  public static readonly C_TOUROKU_KBN_ADD_INFO = '2';
  public static readonly C_TOUROKU_KBN_ADD_INFO_NAME = '追加情報';

  // 約定管理
  // 退去フラグ
  public static readonly C_TAIKYO_FLG_MI = '0';
  public static readonly C_TAIKYO_FLG_MI_NAME = '未退去';
  public static readonly C_TAIKYO_FLG_ZUMI = '1';
  public static readonly C_TAIKYO_FLG_ZUMI_NAME = '退去済';
  // 無効フラグ
  public static readonly C_INVALID_FLG_MI = '0';
  public static readonly C_INVALID_FLG_MI_NAME = '-';
  public static readonly C_INVALID_FLG_ZUMI = '1';
  public static readonly C_INVALID_FLG_ZUMI_NAME = '無効';
  // 支払方法
  public static readonly C_SHIHARAI_HOUHOU_HIKI = '1';
  public static readonly C_SHIHARAI_HOUHOU_HIKI_NAME = '引落';
  public static readonly C_SHIHARAI_HOUHOU_FURI = '2';
  public static readonly C_SHIHARAI_HOUHOU_FURI_NAME = '振込';

  // 管理会社返金
  // 返金ステータス
  public static readonly C_HENKIN_STS_HUYO = '0';
  public static readonly C_HENKIN_STS_HUYO_NAME = '不要';
  public static readonly C_HENKIN_STS_IRAIMATI = '1';
  public static readonly C_HENKIN_STS_IRAIMATI_NAME = '依頼待ち';
  public static readonly C_HENKIN_STS_IRAICHU = '2';
  public static readonly C_HENKIN_STS_IRAICHU_NAME = '依頼中';
  public static readonly C_HENKIN_STS_ZUMI = '3';
  public static readonly C_HENKIN_STS_ZUMI_NAME = '返金済み';

  // 月額手数料振込-月額／年額区分
  // 月額／年額区分
  public static readonly C_GETUGAKU_NENGAKU_KBN_GETU = '1';
  public static readonly C_GETUGAKU_NENGAKU_KBN_GETU_NAME = '月額';
  public static readonly C_GETUGAKU_NENGAKU_KBN_NEN = '2';
  public static readonly C_GETUGAKU_NENGAKU_KBN_NEN_NAME = '年額';

  public static readonly C_AI_ERROR = 'AIスコアの取得処理に失敗しました。'; // AIスコア処理エラー
  public static readonly C_AI_POP_TITLE = '未入力項目'; // ポップアップタイトル

  // 対応方法
  public static readonly C_TODO_TAIOU_HOUHOU_SHUDO = '0'; // 手動
  public static readonly C_TODO_TAIOU_HOUHOU_JIDO = '1'; // 自動
  public static readonly C_TODO_TAIOU_HOUHOU_SHUDO_NAME = '手動';
  public static readonly C_TODO_TAIOU_HOUHOU_JIDO_NAME = '自動';

  // MP契約番号重複有無
  public static readonly C_MP_KEIYAKU_NO_CHOFUKU_NASHI = '0'; // MP契約番号重複無し
  public static readonly C_MP_KEIYAKU_NO_CHOFUKU_ARI = '1'; // MP契約番号重複有り

  // 口座検索画面用ラベル名称
  public static readonly KOZA_LABEL_SINSA_FURIKOMI = '審査契約登録更新/振込口座選択中'; // 審査契約登録更新画面の振込口座ボタン押下時
  public static readonly KOZA_LABEL_SINSA_HIKIOTOSI = '審査契約登録更新/引落口座選択中'; // 審査契約登録更新画面の引落口座ボタン押下時
  public static readonly KOZA_LABEL_SIHARAI_SHUKIN = '支払状況登録更新/出金口座選択中'; // 支払状況登録更新画面の出金口座ボタン押下時
  public static readonly KOZA_LABEL_SIHARAI_NYUKIN = '支払状況登録更新/入金口座選択中'; // 支払状況登録更新画面の入金口座ボタン押下時
  public static readonly KOZA_LABEL_FUDOUSAN_OYA_YATIN = '不動産会社支店大家登録更新/家賃振込口座選択中'; // 不動産会社支店大家画面の家賃振込口座ボタン押下時
  public static readonly KOZA_LABEL_FUDOUSAN_YATIN = '不動産会社登録更新/家賃振込口座選択中'; // 不動産会社登録更新画面の家賃振込口座ボタン押下時
  public static readonly KOZA_LABEL_FUDOUSAN_TESURYO = '不動産会社登録更新/代理店手数料振込口座選択中'; // 不動産会社登録更新画面の代理店手数料振込口座ボタン押下時
  public static readonly KOZA_LABEL_FUDOUSAN_GETUGAKU = '不動産会社登録更新/月額手数料振込口座選択中'; // 不動産会社登録更新画面の月額手数料振込口座ボタン押下時
  public static readonly KOZA_LABEL_FUDOUSAN_JISHAHOSHOU = '不動産会社登録更新/自社保証初回保証料振込口座選択中'; // 不動産会社登録更新画面の自社保証初回保証料振込口座ボタン押下時
  public static readonly KOZA_LABEL_FUDOUSAN_BUNBETSU_SOUKIN1 = '不動産会社登録更新/その他送金出納1振込口座選択中'; // 不動産会社登録更新画面のその他送金出納1振込口座ボタン押下時
  public static readonly KOZA_LABEL_FUDOUSAN_BUNBETSU_SOUKIN2 = '不動産会社登録更新/その他送金出納2振込口座選択中'; // 不動産会社登録更新画面のその他送金出納2振込口座ボタン押下時
  public static readonly KOZA_LABEL_FUDOUSAN_SITEN_YATIN = '不動産会社支店登録更新/家賃振込口座選択中'; // 不動産会社支店登録更新画面の家賃振込口座ボタン押下時
  public static readonly KOZA_LABEL_FUDOUSAN_SITEN_DAIRITEN = '不動産会社支店登録更新/代理店手数料振込口座選択中'; // 不動産会社支店登録更新画面の代理店手数料振込口座ボタン押下時
  public static readonly KOZA_LABEL_FUDOUSAN_SITEN_GETUGAKU = '不動産会社支店登録更新/月額手数料振込口座選択中'; // 不動産会社支店登録更新画面の月額手数料振込口座ボタン押下時
  public static readonly KOZA_LABEL_SINSA_MOUSHIKOMI_SHUNO =
    '審査契約申込書登録更新/RFIが口振をかける契約者の口座選択中'; // 審査契約登録更新画面の振込口座ボタン押下時
  public static readonly KOZA_LABEL_SINSA_MOUSHIKOMI_SUITO = '審査契約申込書登録更新/代位弁済口座選択中'; // 審査契約登録更新画面の振込口座ボタン押下時
  public static readonly KOZA_LABEL_ORICO_KAMEITEN_ENTRY = 'OCS加盟店登録変更/出納口座選択中'; // OCS加盟店登録画面の口座検索ボタン押下時
  public static readonly C_KOZA_LABEL_SENTAKUBIKO = '選択備考/代位弁済口座選択中'; // 選択備考登録変更画面の口座検索ボタン押下時

  // システム情報
  public static readonly XML_ORA_USER_ID = 'User Id';
  public static readonly XML_ORA_PASSWORD = 'Password';
  public static readonly XML_ORA_DATA_SOURCE = 'Data Source';

  // ファイルパス
  // メニュー番号クラス一覧XMLファイル
  public static readonly XML_FILE_PATH_FORM_CLASS = 'FormClass.xml';
  // DB設定XMLファイル
  public static readonly XML_FILE_PATH = 'dbconnection.xml';

  // Solr接続情報
  // 検索コレクションコード
  public static readonly KEIYAKU_CONNECTION_CODE = '01'; // 契約コレクションコード
  public static readonly SHIHARAI_CONNECTION_CODE = '02'; // 支払コレクションコード
  public static readonly NIPPOU_CONNECTION_CODE = '03'; // 日報コレクションコード
  public static readonly TEL_CONNECTION_CODE = '04'; // 電話コレクションコード
  public static readonly YOCHUI_CONNECTION_CODE = '06'; // 要注意コレクションコード

  public static readonly NewLine = '\n';
  public static readonly vbCr = '\r';
  public static readonly vbLf = '\n';
  public static readonly vbCrLf = '\r\n';

  /**
   * コンマ
   */
  public static readonly COMMA = ',';

  /** スペースハーフサイズの定数値 */
  public static readonly SPACE_HALF_SIZE = ' ';

  /** フルサイズのスペースの定数値 */
  public static readonly SPACE_FULL_SIZE = '　';

  /** ロケール：en-US  */
  public static readonly LOCALE_EN_US = 'en-US';

  /** 時間フォーマット(YYYY-MM-DD HH:mm:ss)*/
  public static readonly DATE_FORMAT_YYYYMMDDHHMMSS_DASH = 'YYYY-MM-DD HH:mm:ss';

  /** 時間フォーマット(yyyyMMdd)*/
  public static readonly DATE_FORMAT_DATA_YYYYMMDD_DAYINMONTH = 'yyyyMMdd';

  /** カレンダー JP */
  public static readonly CALENDAR_JP = 'ja-JP-u-ca-japanese';

  /** 元号 */
  public static readonly ERA = '元';

  /** 汎用 */
  public static readonly MSG_DB_PROCESS_OK = 'DB処理に成功しました。';
  public static readonly MSG_DB_PROCESS_NG = 'DB処理に失敗しました。';

  /** 汎用コンボボックスメッセージ */
  public static readonly MSG_COMBO_BOX_SET = '<コンボボックス項目セット>';

  /** 汎用マスタ 種別コード */
  public static readonly C_MST_HANYO_TABLE_READ_F2 = 'F02';
  public static readonly C_MST_HANYO_FILE_TYPE_F2 = 'F02';
  public static readonly C_MST_HANYO_TABLE_READ_F3 = 'F03';
  public static readonly C_MST_HANYO_FILE_TYPE_F3 = 'F03';

  /** 外部接続ファイル種別 */
  public static readonly C_FILE_TYPE_CODE0 = 0;
  public static readonly C_FILE_TYPE_CODE1 = 1;
  public static readonly C_FILE_TYPE_CODE2 = 2;
  public static readonly C_FILE_TYPE_CODE3 = 3;
  public static readonly C_FILE_TYPE_CODE4 = 4;
  public static readonly C_FILE_TYPE_CODE5 = 5;
  public static readonly C_FILE_TYPE_CODE6 = 6;
  public static readonly C_FILE_TYPE_CODE7 = 7;
  public static readonly C_FILE_TYPE_CODE12 = 12;
  public static readonly C_FILE_TYPE_CODE13 = 13;
  public static readonly C_FILE_TYPE_CODE14 = 14;
  public static readonly C_FILE_TYPE_CODE_NUM = 19;
  /**
   *画面名
   */
  public static readonly MSG_FORM_TITLE = '◆画面名：';
  public static readonly MSG_FORM_INIT = '■画面の初期化';

  /** 汎用メッセージ */
  public static readonly MSG_SYSTEM_ERROR = '\n システム管理者へ連絡してください。';
  public static readonly INPUT_CHECK_ERROR = '正しく入力されていない項目が存在します。色付きの項目を修正してください。';
  public static readonly MSG_MENU_NO_SHOW_FORM_ERROR = '画面の初期化に失敗しました。';
  public static readonly INPUT_CHECK_START = '■入力チェック開始';
  public static readonly INPUT_CHECK_OK = '入力チェック：OK';
  public static readonly INPUT_CHECK_NG = '入力チェック：NG';
  public static readonly INPUT_CHECK_END = '■入力チェック終了';
  public static readonly UNEXPECTED_ERROR = '予期せぬエラーが発生しました。';
  public static readonly MSG_COMBO_BOX_SUCCESS = 'コンボボックスのデータの取得に成功しました。';
  public static readonly MSG_SEARCH_ERROR = 'データの取得に失敗しました。';
  public static readonly MSG_ENTRY_NG = '登録処理に失敗しました。';
  public static readonly MSG_COMBO_BOX_ERROR = 'コンボボックスの読み込みに失敗しました。';
  public static readonly MSG_SEARCH_RESULT = '件該当しました';
  public static readonly MSG_SEARCH_RESULT_ERROR = '検索が失敗しました';

  /** 送金方法 */
  public static readonly SOUKIN_HOUHOU_RFI = '1'; // チェック有
  public static readonly SOUKIN_HOUHOU_MULTI = '2'; // チェック無
  public static readonly MSG_READ_XML_ERR = '設定ファイルの読込に失敗しました。';
  public static readonly C_XML_FILE_NAME_SENDERINFO = 'SenderInfo.xml';
  public static readonly C_XML_TAG_YATIN_REPORT = 'YatinReport';

  /**バッチ系メッセージ */
  public static readonly MSG_BAT_YN = '上記の内容で作成しますか？(Y/N)';
  public static readonly MSG_BAT_NOCOUNT = '該当するデータはありませんでした。';

  /** 0件更新エラー番号 */
  public static readonly C_ORACLE_ERROR_RECORD_UPDATE_NO = '-20005';

  public static readonly MSG_BAT_Y_MAKE_OK = '明細を作成しました。';

  // 登録メッセージ
  public static readonly MSG_ENTRY_CONFIRM = '上記の内容で登録しますか？(Y/N)';

  // 秒単位の非同期APIコール間隔
  public static readonly ASYNC_INTERVAL_IN_SECONDS = '300';
}
